import { render, staticRenderFns } from "./DataDetail.vue?vue&type=template&id=61bd1f7d&scoped=true"
import script from "./DataDetail.vue?vue&type=script&lang=js"
export * from "./DataDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bd1f7d",
  null
  
)

export default component.exports